module.exports = __webpack_public_path__ + "img/tree-01-j-leaves.818e3bae.png";